import { Modal as AntdModal, Button } from "antd";
import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";
import { useModal } from "../context/ModalContext";
import { use } from "i18next";
import { useEffect, useState } from "react";
import { useIsSmallScreen } from "../utils/useMediaQuery";

export default function Modal() {
    const isSmallScreen = useIsSmallScreen(992);
    const { modal, closeModal } = useModal();
    const [reRender, setReRender] = useState(false)
    const [render, setRender] = useState(false)
    const [isFullScreen, setIsFullScreen] = useState(false);

    // modal yeniden acildiginda component guncellenmiyor.
    // render ile tekrar renderlanmaya zorlaniyor.
    useEffect(() => {
        if (modal.open) {
            setReRender(true)
            setRender(false)

            const savedState = localStorage.getItem('modal-fullscreen') === 'true';
            setIsFullScreen(savedState);
        }
    }, [modal.open])

    const toggleFullScreen = () => {
        const newState = !isFullScreen;
        setIsFullScreen(newState);
        localStorage.setItem('modal-fullscreen', newState);
    }

    useEffect(() => {
        if (reRender) {
            setTimeout(() => {
                setRender(true)
                setReRender(false)
            }, 100)
        }
    }, [reRender])

    return (
        <div>
            {
                modal.open && (
                    <AntdModal
                        style={
                            isFullScreen
                                ? { top: 0, margin: 0, padding: 0, maxWidth: '100vw', height: '100vh' }
                                : (isSmallScreen ? { top: 10, margin: 10, maxWidth: 'calc(100% - 20px)' } : { top: modal.top || window.innerHeight * 0.2 })
                        }
                        width={isFullScreen ? '100%' : (isSmallScreen ? '100%' : (modal.width || window.innerWidth * 0.6))}
                        visible={modal.open}
                        title={
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingRight: 24 }}>
                                <span>{modal.title}</span>
                                <Button
                                    type="text"
                                    icon={isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
                                    onClick={toggleFullScreen}
                                />
                            </div>
                        }
                        onCancel={closeModal}
                        onOk={false}
                        footer={false}
                        bodyStyle={isFullScreen ? { height: 'calc(100vh - 55px)', overflowY: 'auto' } : {}}
                    >
                        {
                            render && modal.component
                        }
                    </AntdModal>
                )
            }
            {
                modal?.modal2?.open && (
                    <AntdModal
                        style={{ marginTop: 24 }}
                        width={isSmallScreen ? '100%' : window.innerWidth * 0.5}
                        visible={modal.modal2.open}
                        title={modal.modal2.title}
                        onCancel={closeModal}
                        onOk={false}
                        footer={false}
                    >
                        {
                            render && modal.modal2.component
                        }
                    </AntdModal>
                )
            }
        </div>
    )
}
